import { fromJS } from 'immutable'

import {
  GET_REPORT_CONTEXT_DATA,
  GET_REPORT_CONTEXT_DATA_ERROR,
  GET_REPORT_CONTEXT_DATA_SUCCESS,
  GET_REPORT_CONTEXT_DATA_PROGRESS_SUCCESS,
  INVALIDATE_REPORT_CONTEXT_DATA_CACHE,
  INVALIDATE_REPORT_CONTEXT_DATA_CACHE_ERROR,
  INVALIDATE_REPORT_CONTEXT_DATA_CACHE_SUCCESS,
  REPORT_CONTEXT_DATA_WAITING_FOR_CALCULATION,
} from './constants'

import { UPDATE_REPORT_SELECTION_SUCCESS } from 'containers/Reports/constants'
import { waitingForCalculationProgress } from 'utils/actualsCalculationWait'

const initialState = fromJS({})

const contextReportDatasReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_REPORT_CONTEXT_DATA:
    case INVALIDATE_REPORT_CONTEXT_DATA_CACHE:
      return state.setIn([action.companyCode, action.reportId], {
        data: undefined,
        error: false,
        loading: true,
        progress: undefined,
      })

    case GET_REPORT_CONTEXT_DATA_ERROR:
    case INVALIDATE_REPORT_CONTEXT_DATA_CACHE_ERROR:
      return state.setIn([action.companyCode, action.reportId], {
        loading: false,
        error: action.error,
        progress: undefined,
      })

    case GET_REPORT_CONTEXT_DATA_SUCCESS:
      return state.setIn([action.companyCode, action.reportId], {
        data: action.report,
        error: false,
        loading: false,
        progress: undefined,
      })

    // Still loading, and now with a reason to show for it. The request is repeated until the
    // calculation releases the company, so this is a stop on the way to data, not an outcome. The
    // synthesized progress string goes into the same `progress` field a real progress frame fills,
    // so the widgets' existing `<LoadingIndicator progress={reportData?.progress} />` shows the
    // sentence without any of them changing.
    case REPORT_CONTEXT_DATA_WAITING_FOR_CALCULATION:
      return state.updateIn(
        [action.companyCode, action.reportId],
        (current) => ({
          ...current,
          loading: true,
          error: false,
          waitingForCalculation: action.companies,
          progress: waitingForCalculationProgress(action.companies),
        })
      )

    case GET_REPORT_CONTEXT_DATA_PROGRESS_SUCCESS:
      const { companyCode, progress, reportId } = action
      // A progress frame means a read is in flight and the API is narrating the wait itself, so the
      // client's own waiting line has stopped being the live one - see REPORT_DATA's reducer for the
      // same swap.
      return state.updateIn([companyCode, reportId], (current) => ({
        ...current,
        progress,
        waitingForCalculation: undefined,
      }))

    case INVALIDATE_REPORT_CONTEXT_DATA_CACHE_SUCCESS:
      return state.deleteIn([action.companyCode, action.reportId])

    case UPDATE_REPORT_SELECTION_SUCCESS: {
      const reportSelectionId = action?.reportSelection?.id

      return reportSelectionId
        ? state.map((company) => company.delete(reportSelectionId.toString()))
        : state
    }

    default:
      return state
  }
}

export default contextReportDatasReducer
